import Watchable from '@/mixins/watchable'
import * as Utils from '@/lib/data/Validations/utils/Utils'
import {clone} from '@/lib/helper/helper.js'

const isPlainObject = val => !!val && typeof val === 'object' && val.constructor === Object
export default {
  mixins: [Watchable],
  data() {
    return {
      filtersModelFieldName: 'filtersModel',
      filtersModel         : {
        lang: ''
      }
    }
  },
  methods: {
    initFiltersModel() {
      const filtersModel = this[this.filtersModelFieldName] || {}
      const filtersObj = isPlainObject(filtersModel) ? {...filtersModel} : {}
      const filtersKeys = isPlainObject(filtersObj) ? Object.keys(filtersObj) : []

      filtersKeys.filter(key => key !== 'lang').forEach(key => {
        this.watch(`${this.filtersModelFieldName}.${key}.value`, this.onFilterChange)
      })
    },

    onFilterChange() {
      if (this.dataTable?.options?.page) this.dataTable.options.page = 1
      if (Utils.isFunction(this.getData) && !!this.dataTable?.options?.serverSideEnabled && this.dataTable?.options?.itemsPerPage > -1) this.getData()
    }
  },
  watch   : {},
  computed: {
    filterData() {
      const filtersModel = this[this.filtersModelFieldName] || {}
      const filtersLangObj = this.$te(`${filtersModel.lang}.Filter`) ? this.$t(`${filtersModel.lang}.Filter`) : {}
      const filtersLangKeys = isPlainObject(filtersLangObj) ? Object.keys(filtersLangObj) : []
      const filtersObj = isPlainObject(filtersModel) ? {...filtersModel} : {}
      const filtersKeys = isPlainObject(filtersObj) ? Object.keys(filtersObj) : []

      const retVal = filtersLangKeys.filter(key => filtersKeys.includes(key) && !filtersModel[key]?.disabled).reduce((obj, key) => {
        obj[key] = filtersLangObj[key]
        return obj
      }, {})

      return clone(retVal)
    },

    filterPayload() {
      const retVal = {}
      const filtersModel = this[this.filtersModelFieldName] || {}
      const filtersObj = isPlainObject(filtersModel) ? {...filtersModel} : {}
      const filtersKeys = isPlainObject(filtersObj) ? Object.keys(filtersObj) : []

      filtersKeys.filter(key => key !== 'lang').forEach(key => {
        if (filtersModel[key]?.key) retVal[filtersModel[key].key] = filtersModel[key]?.value || null
      })

      return filtersKeys.length ? clone(retVal) : null
    }

  },
  beforeMount() {
    this.initFiltersModel()
  }
}
